export default __webpack_public_path__ + "static/media/icone-lixeira-branco.8ecafcb4.svg";